const componentStatus = adapter => params => {
  return adapter.callAction('componentStatus', params)
}

export default componentStatus
